wbApp.controller('TenantRegistrationCtrl', ['$window', '$scope', '$timeout', '$translate', '$http', '$modal', 'tenantInfo', 'tenantSettingSvc', 'notificationSvc',
function ($window, $scope, $timeout, $translate, $http, $modal, tenantInfo, tenantSettingSvc, notificationSvc) {

    $scope.model = {
        currency: 'CZK',
        countryCode: 'CZ'
    }

    $scope.isSaveBusy = false;
    $scope.tenantInfo = tenantInfo;
    $scope.tenantFriendlyName = tenantInfo.friendlyName;
    $scope.registerTenantHeader = $translate.instant('TXT_REGISTER_TENANT').f(tenantInfo.friendlyName);

    $scope.tabs = [
    {
        title: 'TXT_TITLE_REGISTRATION',
        template: 'tenant-registration/tenant-registration-tab.html'
    }, {
        title: 'TXT_LBL_USER',
        template: 'tenant-registration/admin-registration-tab.html'
    }, {
        title: 'TXT_LBL_SETTING',
        template: 'tenant-registration/setting-registration-tab.html'
    }];

    $scope.tabs.activeTab = 0;

    $scope.getAddress = function (viewValue) {
        if (viewValue) {
            var params =
                {
                    address: viewValue,
                    sensor: false,
                    key: 'AIzaSyDdpRFWJaEcASaUgQxTdi8i42aaCaKfS0A'
                };
            return $http.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params })
            .then(function (res) {
                return res.data.results;
            });
        }
    };


    var paneCtrls = [];
    $scope.$on('$includeContentLoaded', function (event) {
        paneCtrls.push(event.targetScope.$$childTail);
        event.stopPropagation();
    });

    $scope.serverErrors = null;
    $scope.formErrors = {};

    $scope.areAllFormsValid = function () {
        return _.reduce(paneCtrls, function (sum, item) {
            return !!item.form ? sum && item.form.$valid : sum;
        }, true);
    }

    $scope.isCurrentFormValid = function () {
        if ($scope.tabs.activeTab < paneCtrls.length) {
            var form = paneCtrls[$scope.tabs.activeTab].form;
            var isFormValid = !form || form.$valid;
            if (isFormValid) {
                $scope.formErrors = {};
                return true;
            } else {
                $scope.formErrors = form.$error;
            }

        }
        return false;
    }

    $scope.isPrevButtonVisible = function () {
        return $scope.tabs.activeTab > 0;
    }

    $scope.onPrevBtnClick = function () {
        if ($scope.isPrevButtonVisible()) {
            $scope.tabs.activeTab = $scope.tabs.activeTab - 1;
        }
    }

    $scope.isNextButtonVisible = function () {
        return ($scope.tabs.activeTab < ($scope.tabs.length - 1));
    }

    $scope.onNextBtnClick = function () {
        if ($scope.isCurrentFormValid()) {
            if ($scope.isNextButtonVisible()) {
                $scope.tabs.activeTab = $scope.tabs.activeTab + 1;
            }
        }
    }

    $scope.isSaveButtonVisible = function () {
        return $scope.tabs.activeTab === ($scope.tabs.length - 1);
    }

    $scope.isSaveButtonDisabled = function () {
        return $scope.isSaveBusy || !$scope.areAllFormsValid();
    }

    var confirmTenantCreatedDlg = $modal({
        templateUrl: 'tenant-registration/confirm-tenant-crearted-dialog.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    function swithToFirstInvalidForm() {
        var idx = _.findIndex(paneCtrls, function (item) { return !item.form.$valid; });
        if (idx !== -1) {
            $scope.tabs.activeTab = idx;
            $scope.isCurrentFormValid();
        }
    }

    $scope.onSaveBtnClick = function () {
        if ($scope.isSaveBusy) {
            return;
        }

        if (!$scope.isCurrentFormValid()) {
            return;
        }

        if (!$scope.areAllFormsValid()) {
            swithToFirstInvalidForm();
            return;
        }

        $scope.isSaveBusy = true;

        $http({
            method: 'POST',
            url: '/Api/TenantRegistration/RegisterTenant',
            data: $scope.model
        }).success(function (data, status, headers, config) {
            
            confirmTenantCreatedDlg.$promise.then(function () {
                confirmTenantCreatedDlg.$scope.tenantFriendlyName = $scope.model.friendlyName;
                confirmTenantCreatedDlg.$scope.tenantUrl = "https://" + $scope.model.tenantName + tenantInfo.domain;
                confirmTenantCreatedDlg.show();
            });

        }).error(function (data, status, headers, config) {
            $scope.isSaveBusy = false;

            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_SERVER_ERROR'),
                notificationSvc.translateError(data));
        });
    }

    $scope.onConfirmTenantCreatedOkClick = function () {
        $window.location.href = "https://" + $scope.model.tenantName + tenantInfo.domain;
        $scope.isSaveBusy = false;
    }
}]);